import { FieldNumberOutlined, HomeOutlined, SettingOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Form, Input, Layout, Space } from "antd";
import { useEffect, useState } from "react";
import { NamespacedCCParts, TaskDef } from "../../apis/mgmt/api";
import { NamespacedCCPartsListForm } from "../cconfig/NamespacedCCPartsListForm";
import { DataForm } from "../common/DataForm";
import { DataViewProps } from "../common/DataView";
import { useStatefulList } from "../common/List";
import { Content, Header } from 'antd/es/layout/layout';


export const TaskDefForm = function (
    props: DataViewProps<TaskDef>
) {

    const data = props.data;
    const id = data?.id;
    
    const [ selectedTab,setSelectedTab ] = useState("scope");
    useEffect(() => { setSelectedTab('scope'); }, [id]);
    const selectedTabStyle = (tab: string) => selectedTab===tab? {} : {'display': 'none'};

    const namespacedCCPartsList = useStatefulList<NamespacedCCParts>(props.data?.namespacedCCParts, (data) => {
        if (!data.namespace) throw new Error('Namespace is required');
        return data.namespace       
    });
    useEffect(() => { namespacedCCPartsList.setData(data?.namespacedCCParts); }, [data]);

    return (
        <Layout className="h-100" >
        <Header style={{'paddingBottom': '1em'}}>
        <Space.Compact direction="horizontal" >
            <Button type="text" onClick={()=>setSelectedTab('scope')}><HomeOutlined />Ámbito</Button>
            <Button type="text" onClick={()=>setSelectedTab('config')} disabled={!id}><SettingOutlined />Configuración</Button> 
        </Space.Compact>
        </Header>
        <Content className="h-100">
            <div style={selectedTabStyle('scope')} className="h-100">
                <DataForm {...props} >
                    {/* id */}
                    <Form.Item
                        className="input"
                        name="id"
                    >
                        <Input prefix={<FieldNumberOutlined className="site-form-item-icon" />} placeholder="ID" disabled={true} />
                    </Form.Item>

                    {/* name */}
                    <Form.Item
                        className="input"
                        name="name"
                        rules={[{ required: true, message: '¡Please input your Name!' }]}
                    >
                        <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="Name" />
                    </Form.Item>
                </DataForm>
            </div><div style={selectedTabStyle('config')} className="h-100">
                <NamespacedCCPartsListForm {...namespacedCCPartsList} />
            </div>
        </Content>
        </Layout>
    );

};
